import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import NavigationSection from './NavigationSection';
import NavigationItem from './NavigationItem';

// Icons - Simplified icons matching the Figma design
const BagIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z"/>
  </svg>
);

const InfoIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/>
  </svg>
);

const Sidebar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (path: string) => {
    navigate(path);
  };

  const isActive = (path: string) => {
    return location.pathname === path;
  };

  return (
    <div style={{
      width: '200px', // Tabby sidebar width
      height: '100vh',
      backgroundColor: '#F8F9FA', // Tabby gray background
      display: 'flex',
      flexDirection: 'column',
      padding: '20px 16px' // Adjusted padding for Tabby
    }}>
      {/* Tabby Logo/Brand */}
      <div style={{
        paddingBottom: '24px'
      }}>
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 0'
        }}>
          <div style={{
            color: '#000000', // Pure black for logo
            fontWeight: 600,
            fontSize: '20px',
            fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
            letterSpacing: '-0.02em'
          }}>tabby</div>
        </div>
      </div>
      
      {/* Navigation Content */}
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'auto'
      }}>
        <div style={{
          display: 'flex',
          flexDirection: 'column'
        }}>
        
        {/* Website Tools Section */}
        <NavigationSection 
          title="Website Tools" 
          icon={<BagIcon />}
        >
          <NavigationItem
            label="Home"
            isActive={isActive('/')}
            onClick={() => handleNavigation('/')}
          />
          <NavigationItem
            label="History"
            isActive={isActive('/history')}
            onClick={() => handleNavigation('/history')}
          />
        </NavigationSection>

        {/* Information Section */}
        <NavigationSection 
          title="Information" 
          icon={<InfoIcon />}
        >
          <NavigationItem
            label="About"
            isActive={isActive('/about')}
            onClick={() => handleNavigation('/about')}
          />
          <NavigationItem
            label="Help"
            isActive={isActive('/help')}
            onClick={() => handleNavigation('/help')}
          />
        </NavigationSection>

        </div>
      </div>
    </div>
  );
};

export default Sidebar;
